(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9262,6136,152],{

/***/ 53242:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/email",
      function () {
        return __webpack_require__(30016);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 35276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Chip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87918);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19550);
// ** MUI Imports


// ** Third Party Imports

// ** Hooks Imports

const Chip = (props)=>{
    // ** Props
    const { sx , skin , color , rounded  } = props;
    // ** Hook
    const bgColors = (0,src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const colors = {
        primary: {
            ...bgColors.primaryLight
        },
        secondary: {
            ...bgColors.secondaryLight
        },
        success: {
            ...bgColors.successLight
        },
        error: {
            ...bgColors.errorLight
        },
        warning: {
            ...bgColors.warningLight
        },
        info: {
            ...bgColors.infoLight
        }
    };
    const propsToPass = {
        ...props
    };
    propsToPass.rounded = undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Chip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...propsToPass,
        variant: "filled",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            "MuiChip-rounded": rounded,
            "MuiChip-light": skin === "light"
        }),
        sx: skin === "light" && color ? Object.assign(colors[color], sx) : sx
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chip);


/***/ }),

/***/ 4560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5616);
/* harmony import */ var _mui_material_Menu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35294);
/* harmony import */ var _mui_material_Divider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67720);
/* harmony import */ var _mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18972);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93946);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21609);
/* harmony import */ var src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51514);
// ** React Imports


// ** Next Import

// ** MUI Imports






// ** Icon Imports

// ** Hook Import

const MenuItemWrapper = (param)=>{
    let { children , option  } = param;
    if (option.href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            component: (next_link__WEBPACK_IMPORTED_MODULE_2___default()),
            href: option.href,
            ...option.linkProps,
            sx: {
                px: 4,
                py: 1.5,
                width: "100%",
                display: "flex",
                color: "inherit",
                alignItems: "center",
                textDecoration: "none"
            },
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
};
const OptionsMenu = (props)=>{
    // ** Props
    const { icon , options , menuProps , iconProps , leftAlignMenu , iconButtonProps  } = props;
    // ** State
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    // ** Hook & Var
    const { locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const { settings  } = (0,src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_5__/* .useSettings */ .r)();
    const { direction  } = settings;
    const [arrowDown, setArrowDown] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
        setArrowDown(!arrowDown);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
        setArrowDown(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                "aria-haspopup": "true",
                onClick: handleClick,
                ...iconButtonProps,
                children: [
                    icon ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: "mdi:dots-vertical",
                        ...iconProps
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "current-language",
                        style: {
                            fontWeight: "600",
                            fontSize: "14px",
                            textTransform: "capitalize"
                        },
                        children: [
                            locale || "en",
                            " "
                        ]
                    }),
                    arrowDown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: "ic:round-keyboard-arrow-down"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: "ic:round-keyboard-arrow-up"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Menu__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                keepMounted: true,
                anchorEl: anchorEl,
                onClose: handleClose,
                open: Boolean(anchorEl),
                ...!leftAlignMenu && {
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: direction === "ltr" ? "right" : "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: direction === "ltr" ? "right" : "left"
                    }
                },
                ...menuProps,
                children: options.map((option, index)=>{
                    if (typeof option === "string") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            onClick: handleClose,
                            children: option
                        }, index);
                    } else if ("divider" in option) {
                        return option.divider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Divider__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            ...option.dividerProps
                        }, index);
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            ...option.menuItemProps,
                            ...option.href && {
                                sx: {
                                    p: 0
                                }
                            },
                            onClick: (e)=>{
                                handleClose();
                                option.menuItemProps && option.menuItemProps.onClick ? option.menuItemProps.onClick(e) : null;
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MenuItemWrapper, {
                                option: option,
                                children: [
                                    option.icon ? option.icon : null,
                                    option.text
                                ]
                            })
                        }, index);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OptionsMenu);


/***/ }),

/***/ 31283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84808);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5616);
// ** React Imports


// ** MUI Imports


const Sidebar = (props)=>{
    // ** Props
    const { sx , show , direction , children , hideBackdrop , onOpen , onClose , backDropClick  } = props;
    const handleBackdropClick = ()=>{
        if (backDropClick) {
            backDropClick();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (show && onOpen) {
            onOpen();
        }
        if (show === false && onClose) {
            onClose();
        }
    }, [
        onClose,
        onOpen,
        show
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                sx: {
                    top: 0,
                    height: "100%",
                    zIndex: "drawer",
                    position: "absolute",
                    transition: "all 0.25s ease-in-out",
                    backgroundColor: "background.paper",
                    ...show ? {
                        opacity: 1
                    } : {
                        opacity: 0
                    },
                    ...direction === "right" ? {
                        left: "auto",
                        right: show ? 0 : "-100%"
                    } : {
                        right: "auto",
                        left: show ? 0 : "-100%"
                    },
                    ...sx
                },
                children: children
            }),
            hideBackdrop ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                open: show,
                transitionDuration: 250,
                onClick: handleBackdropClick,
                sx: {
                    position: "absolute",
                    zIndex: (theme)=>theme.zIndex.drawer - 1
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Sidebar);
Sidebar.defaultProps = {
    direction: "left"
};


/***/ }),

/***/ 66136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SettingsConsumer": function() { return /* binding */ SettingsConsumer; },
/* harmony export */   "SettingsContext": function() { return /* binding */ SettingsContext; },
/* harmony export */   "SettingsProvider": function() { return /* binding */ SettingsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30152);
// ** React Imports


// ** ThemeConfig Import

const initialSettings = {
    themeColor: "primary",
    mode: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].mode,
    skin: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].skin,
    footer: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].footer,
    layout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    lastLayout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    direction: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].direction,
    navHidden: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navHidden,
    appBarBlur: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBarBlur,
    navCollapsed: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navCollapsed,
    contentWidth: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].contentWidth,
    toastPosition: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].toastPosition,
    verticalNavToggleType: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].verticalNavToggleType,
    appBar: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout === "horizontal" && src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar === "hidden" ? "fixed" : src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar
};
const staticSettings = {
    appBar: initialSettings.appBar,
    footer: initialSettings.footer,
    layout: initialSettings.layout,
    navHidden: initialSettings.navHidden,
    lastLayout: initialSettings.lastLayout,
    toastPosition: initialSettings.toastPosition
};
const restoreSettings = ()=>{
    let settings = null;
    try {
        const storedData = window.localStorage.getItem("settings");
        if (storedData) {
            settings = {
                ...JSON.parse(storedData),
                ...staticSettings
            };
        } else {
            settings = initialSettings;
        }
    } catch (err) {
        ;
    }
    return settings;
};
// set settings in localStorage
const storeSettings = (settings)=>{
    const initSettings = Object.assign({}, settings);
    delete initSettings.appBar;
    delete initSettings.footer;
    delete initSettings.layout;
    delete initSettings.navHidden;
    delete initSettings.lastLayout;
    delete initSettings.toastPosition;
    window.localStorage.setItem("settings", JSON.stringify(initSettings));
};
// ** Create Context
const SettingsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    saveSettings: ()=>null,
    settings: initialSettings
});
const SettingsProvider = (param)=>{
    let { children , pageSettings  } = param;
    // ** State
    const [settings, setSettings] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        ...initialSettings
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const restoredSettings = restoreSettings();
        if (restoredSettings) {
            setSettings({
                ...restoredSettings
            });
        }
        if (pageSettings) {
            setSettings({
                ...settings,
                ...pageSettings
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSettings
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (settings.layout === "horizontal" && settings.mode === "semi-dark") {
            saveSettings({
                ...settings,
                mode: "light"
            });
        }
        if (settings.layout === "horizontal" && settings.appBar === "hidden") {
            saveSettings({
                ...settings,
                appBar: "fixed"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.layout
    ]);
    const saveSettings = (updatedSettings)=>{
        storeSettings(updatedSettings);
        setSettings(updatedSettings);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SettingsContext.Provider, {
        value: {
            settings,
            saveSettings
        },
        children: children
    });
};
const SettingsConsumer = SettingsContext.Consumer;


/***/ }),

/***/ 19550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5026);
// ** MUI Imports

// ** Util Import

const UseBgColor = ()=>{
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return {
        primaryFilled: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main
        },
        primaryLight: {
            color: theme.palette.primary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.primary.main, 0.12)
        },
        secondaryFilled: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main
        },
        secondaryLight: {
            color: theme.palette.secondary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.secondary.main, 0.12)
        },
        successFilled: {
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.main
        },
        successLight: {
            color: theme.palette.success.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.success.main, 0.12)
        },
        errorFilled: {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main
        },
        errorLight: {
            color: theme.palette.error.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.error.main, 0.12)
        },
        warningFilled: {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.main
        },
        warningLight: {
            color: theme.palette.warning.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.warning.main, 0.12)
        },
        infoFilled: {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.main
        },
        infoLight: {
            color: theme.palette.info.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.info.main, 0.12)
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (UseBgColor);


/***/ }),

/***/ 51514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66136);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__.SettingsContext);


/***/ }),

/***/ 5026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ hexToRGBA; }
/* harmony export */ });
/**
 ** Hex color to RGBA color
 */ const hexToRGBA = (hexCode, opacity)=>{
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) {
        hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 30152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage in order to see the config changes in the template.
 * ! To clear local storage, you may refer https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/.
 */ const themeConfig = {
    // ** Layout Configs
    templateName: "Msafely" /* App Name */ ,
    layout: "vertical" /* vertical | horizontal */ ,
    mode: "light" /* light | dark | semi-dark /*! Note: semi-dark value will only work for Vertical Layout */ ,
    direction: "ltr" /* ltr | rtl */ ,
    skin: "default" /* default | bordered */ ,
    contentWidth: "boxed" /* full | boxed */ ,
    footer: "static" /* fixed | static | hidden */ ,
    // ** Routing Configs
    routingLoader: false,
    // ** Navigation (Menu) Configs
    navHidden: false,
    menuTextTruncate: true,
    navSubItemIcon: "mdi:circle" /* Icon */ ,
    verticalNavToggleType: "accordion" /* accordion | collapse /*! Note: This is for Vertical navigation menu only */ ,
    navCollapsed: false,
    navigationSize: 300 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    afterVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    beforeVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    horizontalMenuToggle: "hover" /* click | hover /*! Note: This is for Horizontal navigation menu only */ ,
    horizontalMenuAnimation: true,
    // ** AppBar Configs
    appBar: "fixed" /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */ ,
    appBarBlur: true,
    // ** Other Configs
    responsiveFontSizes: true,
    disableRipple: false,
    disableCustomizer: false,
    toastPosition: "top-right" /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */ 
};
/* harmony default export */ __webpack_exports__["default"] = (themeConfig);


/***/ }),

/***/ 30016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ email; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(46483);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./src/utils/conversionUtcDate.js
var conversionUtcDate = __webpack_require__(83176);
// EXTERNAL MODULE: ./src/store/apps/android-email/index.js
var android_email = __webpack_require__(26061);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/lib/index.js
var lib = __webpack_require__(51964);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/@core/components/option-menu/index.js
var option_menu = __webpack_require__(4560);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/timers-browserify/main.js
var main = __webpack_require__(602);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./src/@core/hooks/useSettings.js
var useSettings = __webpack_require__(51514);
// EXTERNAL MODULE: ./src/@core/components/sidebar/index.js
var sidebar = __webpack_require__(31283);
// EXTERNAL MODULE: ./src/@core/components/mui/chip/index.js
var chip = __webpack_require__(35276);
;// CONCATENATED MODULE: ./src/views/android/email/MailDetails.js
// ** React Imports


// ** MUI Imports









// ** Icon Imports

// ** Third Party Imports


// ** Hooks

// ** Custom Components Imports



const HiddenReplyBack = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        height: 11,
        width: "90%",
        opacity: 0.5,
        borderWidth: 1,
        borderBottom: 0,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper
    };
});
const HiddenReplyFront = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        height: 12,
        width: "95%",
        opacity: 0.7,
        borderWidth: 1,
        borderBottom: 0,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper
    };
});
const MailDetails = (props)=>{
    // ** Props
    const { mail , hidden , folders , dispatch , direction , updateMail , foldersObj , routeParams , paginateMail , handleStarMail , mailDetailsOpen , handleLabelUpdate , handleFolderUpdate , setMailDetailsOpen  } = props;
    // ** State
    const [showReplies, setShowReplies] = (0,react.useState)(false);
    // ** Hook
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const handleMoveToTrash = ()=>{
        dispatch(updateMail({
            emailIds: [
                mail.id
            ],
            dataToUpdate: {
                folder: "trash"
            }
        }));
        setMailDetailsOpen(false);
    };
    const handleReadMail = ()=>{
        dispatch(updateMail({
            emailIds: [
                mail.id
            ],
            dataToUpdate: {
                isRead: false
            }
        }));
        setMailDetailsOpen(false);
    };
    const handleFoldersMenu = ()=>{
        const array = [];
        if (routeParams && routeParams.folder && !routeParams.label && foldersObj[routeParams.folder]) {
            foldersObj[routeParams.folder].map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(mail.id, folder.name);
                            setMailDetailsOpen(false);
                        }
                    }
                });
            });
        } else if (routeParams && routeParams.label) {
            folders.map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(mail.id, folder.name);
                            setMailDetailsOpen(false);
                        }
                    }
                });
            });
        } else {
            foldersObj["inbox"].map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(mail.id, folder.name);
                            setMailDetailsOpen(false);
                        }
                    }
                });
            });
        }
        return array;
    };
    const prevMailIcon = direction === "rtl" ? "mdi:chevron-right" : "mdi:chevron-left";
    const nextMailIcon = direction === "rtl" ? "mdi:chevron-left" : "mdi:chevron-right";
    const goBackIcon = prevMailIcon;
    const ScrollWrapper = (param)=>{
        let { children  } = param;
        if (hidden) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden"
                },
                children: children
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                options: {
                    wheelPropagation: false
                },
                children: children
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar/* default */.Z, {
        hideBackdrop: true,
        direction: "right",
        show: mailDetailsOpen,
        sx: {
            zIndex: 3,
            width: "100%",
            overflow: "hidden"
        },
        onClose: ()=>{
            setMailDetailsOpen(false);
            setShowReplies(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                padding: "10px",
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: ()=>setMailDetailsOpen(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                style: {
                                    fontSize: "24px",
                                    cursor: "pointer"
                                },
                                icon: "mdi:chevron-left"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "#5e5e5e",
                                fontSize: "14px"
                            },
                            children: (0,conversionUtcDate/* default */.Z)(mail.time, "local", "YYYY-MM-DD HH:mm")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    style: {
                        textAlign: "center",
                        padding: "10px 0",
                        color: "#1F1F1F",
                        fontSize: "1.2rem",
                        fontWeight: "600"
                    },
                    children: mail.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    sx: {
                        m: "0 !important"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        height: "calc(100% - 80px)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
                        style: {
                            overflow: "scroll"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                color: "text.secondary"
                            },
                            className: "email_html",
                            dangerouslySetInnerHTML: {
                                __html: mail.content
                            }
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var email_MailDetails = (MailDetails);

;// CONCATENATED MODULE: ./src/views/android/email/MailLog.js
// ** React Imports


// ** MUI Imports
















// ** Icon Imports

// ** Third Party Imports

// ** Custom Components Imports

// ** Email App Component Imports


const MailItem = (0,styled/* default */.ZP)(ListItem/* default */.ZP)((param)=>{
    let { theme  } = param;
    return {
        cursor: "pointer",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        justifyContent: "space-between",
        transition: "border 0.15s ease-in-out, transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        "&:hover": {
            zIndex: 2,
            boxShadow: theme.shadows[3],
            transform: "translateY(-2px)",
            "& .mail-actions": {
                display: "flex"
            },
            "& .mail-info-right": {
                display: "none"
            },
            "& + .MuiListItem-root": {
                borderColor: "transparent"
            }
        },
        [theme.breakpoints.up("xs")]: {
            paddingLeft: theme.spacing(2.5),
            paddingRight: theme.spacing(2.5)
        },
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5)
        }
    };
});
const ScrollWrapper = (param)=>{
    let { children , hidden  } = param;
    if (hidden) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                height: "100%",
                overflowY: "auto",
                overflowX: "hidden"
            },
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            options: {
                wheelPropagation: false,
                suppressScrollX: true
            },
            children: children
        });
    }
};
const MailLog = (props)=>{
    // ** Props
    const { store , query , hidden , dispatch , setQuery , direction , updateMail , mailDetailsOpen , updateMailLabel , setMailDetailsOpen , handleLeftSidebarToggle  } = props;
    // ** State
    const [refresh, setRefresh] = (0,react.useState)(false);
    // ** Vars
    const folders = [
        {
            name: "draft",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:pencil-outline",
                    fontSize: 20
                })
            })
        },
        {
            name: "spam",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:alert-octagon-outline",
                    fontSize: 20
                })
            })
        },
        {
            name: "trash",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:delete-outline",
                    fontSize: 20
                })
            })
        },
        {
            name: "inbox",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:email-outline",
                    fontSize: 20
                })
            })
        }
    ];
    const foldersConfig = {
        draft: {
            name: "draft",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:pencil-outline",
                    fontSize: 20
                })
            })
        },
        spam: {
            name: "spam",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:alert-octagon-outline",
                    fontSize: 20
                })
            })
        },
        trash: {
            name: "trash",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:delete-outline",
                    fontSize: 20
                })
            })
        },
        inbox: {
            name: "inbox",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:email-outline",
                    fontSize: 20
                })
            })
        }
    };
    const foldersObj = {
        inbox: [
            foldersConfig.spam,
            foldersConfig.trash
        ],
        sent: [
            foldersConfig.trash
        ],
        draft: [
            foldersConfig.trash
        ],
        spam: [
            foldersConfig.inbox,
            foldersConfig.trash
        ],
        trash: [
            foldersConfig.inbox,
            foldersConfig.spam
        ]
    };
    const handleStarMail = (e, id, value)=>{
        e.stopPropagation();
    };
    const handleReadMail = (id, value)=>{
        const arr = Array.isArray(id) ? [
            ...id
        ] : [
            id
        ];
    };
    const handleLabelUpdate = (id, label)=>{
        const arr = Array.isArray(id) ? [
            ...id
        ] : [
            id
        ];
    };
    const handleFolderUpdate = (id, folder)=>{
        const arr = Array.isArray(id) ? [
            ...id
        ] : [
            id
        ];
    };
    const handleRefreshMailsClick = ()=>{
        setRefresh(true);
        (0,main.setTimeout)(()=>setRefresh(false), 1000);
    };
    const mailDetailsProps = {
        hidden,
        folders,
        dispatch,
        direction,
        foldersObj,
        updateMail,
        handleStarMail,
        mailDetailsOpen,
        handleLabelUpdate,
        handleFolderUpdate,
        setMailDetailsOpen,
        mail: store && store.selectedMails ? store.selectedMails : null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "100%",
            overflow: "hidden",
            position: "relative",
            "& .ps__rail-y": {
                zIndex: 5
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: "100%",
                    backgroundColor: "background.paper"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        p: 0,
                        position: "relative",
                        overflowX: "hidden"
                    },
                    style: {
                        height: "calc(var(--vh)*100 - 270px)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
                        hidden: hidden,
                        children: store && store.mails && store.mails.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            sx: {
                                p: 0
                            },
                            children: store.mails.map((mail)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MailItem, {
                                    sx: {
                                        backgroundColor: mail.isRead ? "action.hover" : "background.paper",
                                        borderBottom: "1px solid #ECECEC"
                                    },
                                    onClick: ()=>{
                                        dispatch((0,android_email/* fetchSelectedMails */.sN)(mail));
                                        setMailDetailsOpen(true);
                                        (0,main.setTimeout)(()=>{}, 600);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                mr: 4,
                                                display: "flex",
                                                overflow: "hidden",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    overflow: "hidden",
                                                    flexDirection: {
                                                        xs: "column",
                                                        sm: "row"
                                                    },
                                                    alignItems: {
                                                        xs: "flex-start",
                                                        sm: "center"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            mr: 4,
                                                            fontWeight: 500,
                                                            whiteSpace: "nowrap",
                                                            width: [
                                                                "100%",
                                                                "auto"
                                                            ],
                                                            overflow: [
                                                                "hidden",
                                                                "unset"
                                                            ],
                                                            textOverflow: [
                                                                "ellipsis",
                                                                "unset"
                                                            ],
                                                            color: "#403F3F"
                                                        },
                                                        children: mail.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        noWrap: true,
                                                        variant: "body2",
                                                        sx: {
                                                            width: "100%"
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "caption",
                                                sx: {
                                                    minWidth: "50px",
                                                    textAlign: "right",
                                                    whiteSpace: "nowrap",
                                                    color: "text.disabled"
                                                },
                                                children: (0,conversionUtcDate/* default */.Z)(mail.time, "local", "YYYY-MM-DD HH:mm")
                                            })
                                        })
                                    ]
                                }, mail.id);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                mt: 6,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                "& svg": {
                                    mr: 2
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "mdi:alert-circle-outline",
                                    fontSize: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    children: "No Mails Found"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_MailDetails, {
                ...mailDetailsProps
            })
        ]
    });
};
/* harmony default export */ var email_MailLog = (MailLog);

// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./node_modules/antd/es/pagination/index.js + 13 modules
var pagination = __webpack_require__(11004);
// EXTERNAL MODULE: ./src/pages/android/email/index.module.scss
var index_module = __webpack_require__(27767);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 83 modules
var date_picker = __webpack_require__(15378);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/components/ContentLoading/index.js
var ContentLoading = __webpack_require__(74743);
// EXTERNAL MODULE: ./src/utils/dateRangeParams.js
var dateRangeParams = __webpack_require__(31909);
;// CONCATENATED MODULE: ./src/pages/android/email/index.js
// ** React Imports

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n  .ant-picker-input {// 包裹显示两个时间input的div样式\n    width:auto;\n  }\n  .ant-picker-input > input {// 显示两个时间的input样式\n    font-family: Poppins !important;\n    font-weight: 400 !important;\n    line-height: 24px !important;\n    font-size: 16px !important;\n    text-align: center;\n    text-overflow: clip !important;  /* 禁止使用省略号 */\n    overflow: visible !important;    /* 允许文本溢出 */\n  }\n  .ant-picker-input input[date-range="start"] {\n  width: var(--firstWidth) !important;\n  }\n  .ant-picker-input input[date-range="end"] {\n    width: var(--lastWidth) !important;\n  }\n  .ant-picker-input > input::placeholder {// 显示两个时间的placeholder样式（占位符\n    color:#ADADAD;\n  }\n  .ant-picker-suffix {// 框内icon样式\n    order:-1;\n    opacity:1 !important;\n    margin-right:11px;\n  }\n  '
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



// ** Redux Imports

// ** MUI Imports



// ** Email App Component Imports

// ** Actions













const { RangePicker  } = date_picker/* default */.Z;
const CustomRangePicker = (0,styled/* default */.ZP)(RangePicker)(_templateObject());
const ScrollDiv = (0,styled/* default */.ZP)("ul")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const EmailAppLayout = ()=>{
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    // ** States
    const [composeOpen, setComposeOpen] = (0,react.useState)(false);
    const [mailDetailsOpen, setMailDetailsOpen] = (0,react.useState)(false);
    // ** Hooks
    const theme = (0,useTheme/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [mailBoxes, setMailBoxes] = (0,react.useState)(0) // 移动端显示层级
    ;
    const allEmails = (0,es/* useSelector */.v9)((state)=>state.androidEmail.allEmails) // 全部邮件列表
    ;
    const [emailList, setEmailList] = (0,react.useState)([]) // 当前显示的邮件列表
    ;
    const selectedMails = (0,es/* useSelector */.v9)((state)=>state.androidEmail.selectedMails) // 全部邮件列表
    ;
    const [antdSelectedDates, setAntdSelectedDates] = (0,react.useState)([]);
    const hidden = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const store = (0,es/* useSelector */.v9)((state)=>state.androidEmail);
    const deviceRequestKey = (0,es/* useSelector */.v9)(Common/* selectDeviceRequestKey */.rx);
    const toggleComposeOpen = ()=>setComposeOpen(!composeOpen);
    const [currentPage, setCurrentPage] = (0,react.useState)(1);
    const [pageSize, setPageSize] = (0,react.useState)(50);
    (0,react.useEffect)(()=>{
        setCurrentPage(1);
        setPageSize(50);
        setMailBoxes(0);
        setMailDetailsOpen(false);
        setAntdSelectedDates([]);
    }, [
        deviceRequestKey
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,android_email/* fetchMails */.d7)(currentPage, pageSize));
    }, [
        currentPage,
        pageSize,
        deviceRequestKey,
        dispatch
    ]);
    // 改每页条数：页码重置为 1，Pagination 会按 total/pageSize 重算总页数
    const handlePaginationChange = (page, size)=>{
        const nextSize = Number(size) || pageSize;
        if (nextSize !== pageSize) {
            setPageSize(nextSize);
            setCurrentPage(1);
            return;
        }
        setCurrentPage(page);
    };
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    (0,react.useEffect)(()=>{
        dispatch((0,Common/* setCurrentTab */.Lw)(t("Email")));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch,
        t
    ]);
    const dom = (0,react.useRef)(null);
    const [scroll, setScroll] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            const { scrollTop , scrollHeight , clientHeight  } = dom.current;
            const progress = scrollTop / (scrollHeight - clientHeight) * 100;
            setScroll(progress.toFixed(0));
        };
        const currentRef = dom.current;
        if (currentRef) currentRef.addEventListener("scroll", handleScroll);
        return ()=>{
            if (currentRef) currentRef.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (scroll >= 100 && store.total !== allEmails.length) setCurrentPage((page)=>page + 1);
    }, [
        allEmails.length,
        scroll,
        store.total
    ]);
    // 获取今天的日期
    const today = dayjs_min_default()().format("YYYY-MM-DD");
    // 获取七天前的日期
    const sevenDaysAgo = dayjs_min_default()().subtract(7, "day").format("YYYY-MM-DD");
    // 列表跟随 store（日期筛选由接口完成）
    (0,react.useEffect)(()=>{
        setEmailList(allEmails);
    }, [
        allEmails
    ]);
    //选择日期范围
    const handleDateChange = (0,react.useCallback)((dates)=>{
        const picked = dates && dates.length === 2 ? dates : [];
        setAntdSelectedDates(picked);
        // 把区间交给 store，由接口按日期重新取数
        const { startTime , endTime  } = (0,dateRangeParams/* buildTimeParams */.W2)(picked);
        dispatch((0,android_email/* setMailDateRange */.G8)(picked.length === 2 ? {
            startTime,
            endTime
        } : null));
        // 回到第一页重新请求；页码本来就等于 1 时 effect 不会触发，这里手动补一次
        if (currentPage !== 1) setCurrentPage(1);
        else dispatch((0,android_email/* fetchMails */.d7)(1, pageSize));
    }, [
        currentPage,
        dispatch,
        pageSize
    ]);
    // 获取最宽日期选择器占位符宽度
    (0,react.useEffect)(()=>{
        // 开始时间&结束时间
        let firstDate = "0000-00-00";
        let lastDate = "0000-00-00";
        // 开始时间宽度&结束时间宽度
        let firstWidth = 0;
        let lastWidth = 0;
        const span = document.createElement("span");
        span.style.setProperty("font-family", "Poppins", "important");
        span.style.setProperty("font-size", "16px", "important");
        span.style.setProperty("font-weight", "400", "important");
        span.style.setProperty("line-height", "24px", "important");
        span.style.visibility = "hidden";
        span.innerText = firstDate;
        // 获取第一个占位符宽度
        document.body.appendChild(span);
        firstWidth = span.offsetWidth;
        document.body.removeChild(span);
        // 获取第二个占位符宽度
        span.innerText = lastDate;
        document.body.appendChild(span);
        lastWidth = span.offsetWidth;
        document.body.removeChild(span);
        // 插入至html标签样式中用于调用
        document.documentElement.style.setProperty("--firstWidth", "".concat(firstWidth, "px"));
        document.documentElement.style.setProperty("--lastWidth", "".concat(lastWidth, "px"));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "format-detection",
                    content: "telephone=no"
                })
            }),
            store.loading && allEmails.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoading/* default */.Z, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: 1,
                            overflow: "hidden",
                            position: "relative",
                            "@media (max-width: 990px)": {
                                display: "none"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).box,
                                style: {
                                    display: "flex",
                                    flexDirection: "row-reverse",
                                    marginBottom: "10px",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                                        className: "ml-[10px]",
                                        current: currentPage,
                                        pageSize: pageSize,
                                        total: store.total,
                                        showSizeChanger: true,
                                        pageSizeOptions: [
                                            "20",
                                            "50",
                                            "100"
                                        ],
                                        style: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        onChange: handlePaginationChange,
                                        onShowSizeChange: handlePaginationChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        style: {
                                            color: "#5e5e5e",
                                            fontSize: "14px"
                                        },
                                        children: [
                                            t("Total"),
                                            ": ",
                                            store.total
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_MailLog, {
                                store: store,
                                hidden: hidden,
                                dispatch: dispatch,
                                mailDetailsOpen: mailDetailsOpen,
                                setMailDetailsOpen: setMailDetailsOpen
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] m-auto hidden smj:flex flex-col",
                        children: [
                            mailBoxes === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    color: "#000000",
                                                    margin: "auto"
                                                },
                                                className: "py-[21px] w-[90%]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        textAlign: "center",
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "500",
                                                        margin: "auto"
                                                    },
                                                    children: t("Mail")
                                                })
                                            }),
                                            emailList && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-full px-[15px] mb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRangePicker, {
                                                        format: "YYYY-MM-DD" // 左右两边显示的日期格式
                                                        ,
                                                        placeholder: [
                                                            sevenDaysAgo,
                                                            today
                                                        ],
                                                        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-[#ADADAD]",
                                                            children: "~"
                                                        }),
                                                        suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "/images/calls/calendar.svg",
                                                            alt: "calendar",
                                                            width: 18,
                                                            height: 18
                                                        }),
                                                        className: "w-full h-[40px] bg-[#F8F8F8]",
                                                        inputReadOnly: true,
                                                        // allowClear={false} // 清除按钮是否显示
                                                        onChange: handleDateChange
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollDiv, {
                                        ref: dom,
                                        className: "w-full px-[15px] overflow-auto",
                                        children: emailList.map((row, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "w-full py-[8px] [border-bottom:1px_solid_#E5E7EB] cursor-pointer",
                                                onClick: ()=>{
                                                    dispatch((0,android_email/* fetchSelectedMails */.sN)(row));
                                                    setMailBoxes(1);
                                                    setTimeout(()=>{}, 600);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            paddingLeft: "3px",
                                                            display: "flex",
                                                            justifyContent: "space-between"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    fontWeight: "600",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                    color: "#000000",
                                                                    maxWidth: "65%",
                                                                    wordBreak: "break-all"
                                                                },
                                                                children: row.source
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    fontWeight: "400",
                                                                    color: "#808080",
                                                                    fontSize: "12px",
                                                                    lineHeight: "18px",
                                                                    paddingRight: "3px"
                                                                },
                                                                children: dayjs_min_default()(row.time).format("YYYY/MM/DD")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            fontWeight: "400",
                                                            paddingLeft: "3px",
                                                            fontSize: "13px",
                                                            lineHeight: "19.5px",
                                                            color: "#222222"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: row.title
                                                        })
                                                    })
                                                ]
                                            }, i))
                                    })
                                ]
                            }),
                            mailBoxes === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                color: "#000000",
                                                margin: "auto",
                                                paddingLeft: "16px"
                                            },
                                            className: "py-[21px] w-[100%]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    icon: "ion:chevron-back",
                                                    onClick: ()=>setMailBoxes(0)
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        textAlign: "center",
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "600",
                                                        margin: "auto"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[24px] h-[24px]"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                width: "100%",
                                                margin: "auto",
                                                height: "auto",
                                                borderBottom: "1px solid #E4E4E6",
                                                display: "flex",
                                                alignItems: "center",
                                                paddingLeft: "16px",
                                                paddingBottom: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        width: "35px",
                                                        height: "35px",
                                                        background: "linear-gradient(180deg, #A5AAB6 0%, #868A93 100%)",
                                                        borderRadius: "50%",
                                                        textAlign: "center",
                                                        lineHeight: "24px",
                                                        fontWeight: "500",
                                                        fontSize: "16px",
                                                        color: "#fff",
                                                        marginRight: "14px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center"
                                                    },
                                                    children: selectedMails.fromName.split(" ").map((word)=>word[0]).join("")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                justifyContent: "space-between",
                                                                display: "flex",
                                                                alignItems: "start"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    style: {
                                                                        fontWeight: "600",
                                                                        fontSize: "16px",
                                                                        lineHeight: "24px",
                                                                        maxWidth: "65%",
                                                                        wordBreak: "break-all"
                                                                    },
                                                                    children: selectedMails.fromName
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    style: {
                                                                        color: "rgba(0, 0, 0, 0.56)",
                                                                        fontSize: "14PX",
                                                                        lineHeight: "21px",
                                                                        paddingRight: "12px"
                                                                    },
                                                                    children: dayjs_min_default()(selectedMails.time).format("YYYY/MM/DD")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                fontSize: "14px",
                                                                lineHeight: "21px",
                                                                fontWeight: "400",
                                                                display: "flex",
                                                                alignItems: "start"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        t("Receipt"),
                                                                        ":"
                                                                    ]
                                                                }),
                                                                "\xa0",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "text-[#959595] max-w-[55%] break-all",
                                                                    children: [
                                                                        selectedMails.toName,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/images/mail/mailunion.svg",
                                                                            width: 7,
                                                                            height: 7,
                                                                            className: "inline-block ml-2",
                                                                            alt: ""
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-1 overflow-auto rounded-[10px]",
                                            dangerouslySetInnerHTML: {
                                                __html: selectedMails.content
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var email = (EmailAppLayout);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ }),

/***/ 27767:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"email_box___y0Ta"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,1675,5378,518,2607,6664,8863,1664,1964,7891,5294,3573,1004,361,9774,2888,179], function() { return __webpack_exec__(53242); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);